export const FETCH_DATA_INIT = "FETCH_DATA_INIT";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const ON_CREATE = "ON_CREATE";
export const ON_UPDATE = "ON_UPDATE";
